import BLOCKS from "./blocks"
import COMMON from "./common"
import COMPONENTS from "./components"
import LAYOUT from "./layout"

const FRAGMENTS = Object.freeze({
	...BLOCKS,
	...COMMON,
	...COMPONENTS,
	...LAYOUT,
})

export default FRAGMENTS
